module.exports = __webpack_public_path__ + "static/media/icon-material-live-help.fe9578f5.svg";